import {
  aYaraRulePage,
  mockYaraRulesOperationQuery,
  mockYaraRulesSearchOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockYaraRulesOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          yaraRules: aYaraRulePage({
            hasNextPage: false,
            objects: [],
            total: 0,
          }),
        },
      });
    }
  ),
  mockYaraRulesSearchOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          yaraRules: aYaraRulePage(),
        },
      });
    }
  ),
];
